import DropdownUserTypes2 from "root/s360components/ui/DropdownUserTypes2";
import FormFilterWrapper from "root/ReactHookForm/ui/FormFilterWrapper";
import DropdownSchools2 from "root/s360components/ui/DropdownSchools2";

const UserEditFilters = ({onSchoolChange, onUserTypeChange}) =>
{

    return (
        <FormFilterWrapper>
            <DropdownSchools2 onChange={onSchoolChange} key={'ds2'}/>
            <DropdownUserTypes2 onChange={onUserTypeChange} key={'dut2'}/>
        </FormFilterWrapper>
    );

}

export default UserEditFilters;